<template>
    <Dialog header="Abonos registrados" v-model:visible="dialogVisible" :modal="true" :closable="false" :style="{'max-width': '460px', width: '90%'}">
        <!-- Historial de abonos (read-only). Pensado para el escenario SIN
             contabilidad automática, donde no existen transacciones que
             consultar: es la única evidencia de cómo se pagó el documento. -->
        <div class="payment-list">
            <div v-for="(payment, index) in payments" :key="payment.id" class="payment-card">
                <div class="payment-index">{{ index + 1 }}</div>
                <div class="payment-body">
                    <div class="payment-top">
                        <span class="payment-amount">${{ formatAmount(payment.amount) }}</span>
                        <span v-if="payment.paymentMethod" class="payment-method-chip">
                            <i :class="methodIcon(payment.paymentMethod)"></i>
                            {{ methodLabel(payment.paymentMethod) }}
                        </span>
                    </div>
                    <div class="payment-meta">
                        <span class="payment-meta-item"><i class="pi pi-calendar"></i> {{ formatDate(payment.createdAt) }}</span>
                        <span v-if="payment.accountName" class="payment-meta-item"><i class="pi pi-wallet"></i> {{ payment.accountName }}</span>
                        <span v-if="payment.creator" class="payment-meta-item"><i class="pi pi-user"></i> {{ payment.creator }}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="payment-total">
            <span>Total abonado</span>
            <span class="payment-total-value">${{ totalPaid }}</span>
        </div>

        <template #footer>
            <Button label="Cerrar" class="p-button-raised p-button-secondary" @click="$emit('onClose')"/>
        </template>
    </Dialog>
</template>

<script>
    export default {
        props: ['payments', 'isVisible'],
        computed: {
            dialogVisible() {
                return this.isVisible;
            },
            totalPaid() {
                const total = (this.payments || []).reduce((sum, p) => sum + Number(p.amount || 0), 0);
                return (Math.round(total * 100) / 100).toFixed(2);
            }
        },
        methods: {
            formatAmount(amount) {
                return Number(amount || 0).toFixed(2);
            },
            formatDate(rawDate) {
                if (!rawDate) return '';
                const date = new Date(rawDate.toString().replace(' ', 'T'));
                if (isNaN(date.getTime())) return rawDate.toString();
                return date.toLocaleDateString('es-EC', { year: 'numeric', month: 'short', day: 'numeric' })
                    + ', ' + date.toLocaleTimeString('es-EC', { hour: '2-digit', minute: '2-digit' });
            },
            methodLabel(code) {
                const method = this.methods().find((m) => m.code === code);
                return method ? method.name : code;
            },
            methodIcon(code) {
                const method = this.methods().find((m) => m.code === code);
                return method ? method.icon : 'pi pi-dollar';
            },
            methods() {
                return [
                    { name: 'Efectivo', code: 'CASH', icon: 'pi pi-money-bill' },
                    { name: 'Transferencia', code: 'TRANSFER', icon: 'pi pi-arrow-right-arrow-left' },
                    { name: 'Cheque', code: 'CHECK', icon: 'pi pi-book' },
                    { name: 'Tarjeta de Débito', code: 'DEBIT_CARD', icon: 'pi pi-credit-card' },
                    { name: 'Tarjeta de Crédito', code: 'CREDIT_CARD', icon: 'pi pi-credit-card' },
                ];
            }
        },
    }
</script>

<style scoped lang="scss">
.payment-list {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}

.payment-card {
    display: flex;
    align-items: stretch;
    background: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05);
    transition: box-shadow 0.15s ease, transform 0.15s ease;

    &:hover {
        box-shadow: 0 4px 10px rgba(16, 24, 40, 0.09);
        transform: translateY(-1px);
    }
}

.payment-index {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 2.25rem;
    background: linear-gradient(160deg, #10b981, #059669);
    color: #ffffff;
    font-weight: 700;
    font-size: 0.9rem;
}

.payment-body {
    flex: 1;
    padding: 0.7rem 0.9rem;
}

.payment-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.4rem;
    gap: 0.5rem;
}

.payment-amount {
    font-size: 1.25rem;
    font-weight: 700;
    color: #065f46;
    letter-spacing: -0.01em;
}

.payment-method-chip {
    display: inline-flex;
    align-items: center;
    gap: 0.3rem;
    background: #ecfdf5;
    color: #047857;
    font-size: 0.75rem;
    font-weight: 600;
    padding: 0.2rem 0.55rem;
    border-radius: 999px;
    white-space: nowrap;

    i {
        font-size: 0.7rem;
    }
}

.payment-meta {
    display: flex;
    flex-wrap: wrap;
    gap: 0.35rem 0.9rem;
}

.payment-meta-item {
    display: inline-flex;
    align-items: center;
    gap: 0.3rem;
    font-size: 0.8rem;
    color: #6b7280;

    i {
        font-size: 0.72rem;
        color: #9ca3af;
    }
}

.payment-total {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 1rem;
    padding: 0.75rem 0.95rem;
    background: #f0fdf4;
    border-radius: 10px;
    font-weight: 700;
    color: #065f46;
}

.payment-total-value {
    font-size: 1.15rem;
}
</style>
